export default {"src":"/_next/static/image/public/images/icons4/1.152836cf986f65e6235d117ad9601363.svg","height":42,"width":42};